<template>
  <div class="col-xs-12 col-sm-12 col-md-12">

    <h4 class="bc-section">
      Período de exibição
      <small>— o aviso só aparece dentro deste período</small>
    </h4>

    <div class="col-xs-12 col-sm-12 col-md-12 bc-dates">
      <div class="form-group">
        <label>Data início</label>
        <input v-model="form.startsAt" type="date" class="form-control bc-date">
      </div>

      <div class="form-group">
        <label>Data final <small>(opcional)</small></label>
        <input v-model="form.endsAt" type="date" class="form-control bc-date">
      </div>
    </div>

    <h4 class="bc-section">Empresas que receberão o aviso</h4>

    <div class="col-xs-12 col-sm-12 col-md-12">
      <div class="checkbox">
        <input v-model="form.targetAllActive" id="targetAllActive" type="checkbox">
        <label v-on:click="form.targetAllActive = !form.targetAllActive">
          Enviar para TODAS as empresas ativas
        </label>
      </div>
      <p class="bc-hint" v-if="form.targetAllActive">
        A audiência é resolvida no servidor no momento do envio. A seleção
        manual abaixo fica desativada.
      </p>
    </div>

    <!-- Erro de busca aparece AQUI. Antes so existia dentro da modal de senha,
         entao uma busca que falhava nao mostrava absolutamente nada. -->
    <div class="col-xs-12 col-sm-12 col-md-12" v-if="searchError">
      <p class="bc-hint bc-hint--error">{{ searchError }}</p>
    </div>

    <div class="col-xs-12 col-sm-9 col-md-9">
      <div class="form-group">
        <input v-model="terms" type="text" class="form-control"
               placeholder="CNPJ, ID ou nome da empresa (separe múltiplos valores com vírgulas)"
               :disabled="form.targetAllActive"
               v-on:keyup.enter="resolveFromTerms">
      </div>
    </div>

    <div class="col-xs-12 col-sm-3 col-md-3">
      <div class="form-group bc-audience__buttons">
        <button type="button" class="btn blue" :disabled="form.targetAllActive"
                v-on:click="resolveFromTerms">Buscar</button>

        <label class="btn default bc-audience__upload" title="Carregar planilha">
          Planilha
          <input type="file" accept=".csv,.txt" v-on:change="onFile">
        </label>
      </div>
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12">
      <!-- Mesma caixa de aviso do Backoffice V2 (WarningBox) e da nova
           liberacao de funcionalidade. -->
      <p class="bc-notice">
        Planilha em CSV ou TXT, identificador na primeira coluna. Para .xlsx,
        salve como CSV antes.
        <a href="#" class="bc-notice__link" @click.prevent="downloadTemplate">Baixar modelo</a>
      </p>
    </div>

    <!-- Resumo da selecao -->
    <div class="col-xs-12 col-sm-12 col-md-12" v-if="selected.length">
      <div class="bc-chips">
        <span class="bc-chips__count">Empresas selecionadas <b>{{ selected.length }}</b></span>
        <button type="button" class="bc-chips__clear" v-on:click="clearSelection">Limpar seleção</button>
      </div>
    </div>

    <!-- Avisos de resolucao -->
    <div class="col-xs-12 col-sm-12 col-md-12" v-if="notFound.length">
      <p class="bc-hint bc-hint--error">
        Sem correspondencia ({{ notFound.length }}): {{ notFound.join(', ') }}
      </p>
    </div>

    <!-- A API acha a empresa mas nao a devolve para selecao: aviso so vai
         para empresa do Brasil. Dizer "sem correspondencia" mandaria procurar
         erro de digitacao numa empresa que existe. -->
    <div class="col-xs-12 col-sm-12 col-md-12" v-if="notBrazil.length">
      <p class="bc-hint bc-hint--error">
        {{ notBrazil.length }} empresa(s) fora do Brasil não podem receber avisos:
        {{ notBrazil.map(companyLabel).join(', ') }}
      </p>
    </div>

    <!--
      Falha de shard nao pode ser silenciosa: numa busca "empresas que NAO tem a
      funcionalidade X" um banco fora do ar transforma as empresas dele em falso
      positivo — a campanha vai para quem ja tem o recurso.
    -->
    <div class="col-xs-12 col-sm-12 col-md-12" v-if="shardsFailed.length">
      <p class="bc-hint bc-hint--error">
        <b>Resultado incompleto.</b> Bancos sem resposta: {{ shardsFailed.join(', ') }}.
        Empresas desses bancos podem estar faltando. Refaca a busca antes de enviar.
      </p>
    </div>

    <!-- Tabela -->
    <div class="col-xs-12 col-sm-12 col-md-12" v-if="rows.length">
      <company-selection-table :rows="rows" :selected.sync="selected" v-on:remove="remove"/>
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12" v-else-if="searched">
      <p class="bc-hint">Nenhuma empresa encontrada para os termos informados.</p>
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 bc-actions">
      <button type="button" class="btn default" v-on:click="$emit('back')">Voltar</button>
      <button type="button" class="btn blue" :disabled="!canSend" v-on:click="openPassword">
        {{ isEdit ? 'Salvar alterações' : 'Enviar aviso' }}
      </button>
    </div>

    <!-- Senha de operacao. Validada no SERVIDOR; aqui e so a coleta. -->
    <div class="bc-modal" v-if="askPassword">
      <div class="bc-modal__box">
        <h4>{{ isEdit ? 'Confirmar alterações' : 'Confirmar envio' }}</h4>
        <p>
          <span v-if="form.targetAllActive">
            O aviso {{ isEdit ? 'passará a valer' : 'será publicado' }} para
            <b>TODAS as empresas ativas</b>.
          </span>
          <span v-else>
            O aviso {{ isEdit ? 'passará a valer' : 'será publicado' }} para
            <b>{{ selected.length }}</b> empresa(s).
          </span>
        </p>
        <div class="form-group">
          <label>Senha de operação</label>
          <input v-model="password" type="password" class="form-control"
                 v-on:keyup.enter="send">
        </div>
        <p class="bc-hint bc-hint--error" v-if="sendError">{{ sendError }}</p>
        <div class="bc-actions">
          <button type="button" class="btn default" v-on:click="askPassword = false">Cancelar</button>
          <button type="button" class="btn blue" :disabled="!password || sending" v-on:click="send">
            {{ sending ? 'Enviando...' : 'Confirmar' }}
          </button>
        </div>
      </div>
    </div>

    <full-loading v-if="resolving"/>
  </div>
</template>

<script>
import fullLoading from "../../components/default/fullLoading.vue";
import companySelectionTable from "./companySelectionTable.vue";
import { isNoCrossToken, requestApiV2 } from "./broadcastApiV2Auth";
import {
  BROADCASTS,
  BROADCAST_BY_ID,
  BROADCAST_RESOLVE_COMPANIES,
} from "../../../../urlConfig";
import { downloadCompanyTemplate, readCompanyTermsFromCsv, splitCompanyTerms } from "./broadcastCsv";
import { audienceToMask, surfacesToMask } from "./broadcastEnums";

// Senha de operacao conferida NO FRONT, igual aos gates de
// detalhes-da-empresa (companyDetail.vue:4544-4558).
//
// Isto e um freio contra envio acidental, nao controle de acesso: o literal
// vai dentro do dist/build.js. O acesso de verdade e o proprio Master (so a
// nossa equipe entra) mais a conferencia de operador da plataforma na API.
// A API NAO recebe nem confere esta senha.
const OPERATION_PASSWORD = 'marqbroadcast';

const serverMessage = (error) => {
  const data = (error && error.response && error.response.data) || {};
  return data.message || data.Message || '';
};

export default {
  name: "broadcast-audience",
  components: { fullLoading, companySelectionTable },
  props: {
    form: { type: Object, required: true },
    /** Preenchido so na edicao: troca o POST de criacao por um PUT. */
    broadcastId: { type: String, default: '' },
    /** Empresas ja direcionadas, carregadas pelo passo 1 na edicao. */
    initialCompanies: { type: Array, default: () => [] },
  },
  data() {
    return {
      terms: '',
      rows: [],
      selected: [],
      notFound: [],
      notBrazil: [],
      shardsFailed: [],
      searched: false,
      searchError: '',
      resolving: false,
      askPassword: false,
      password: '',
      sending: false,
      sendError: '',
    };
  },
  computed: {
    isEdit() {
      return !!this.broadcastId;
    },
    canSend() {
      return (
        (this.form.targetAllActive || this.selected.length > 0) &&
        !!this.form.startsAt &&
        // Sem data final e sem dispensa a campanha nunca sai da tela.
        (!!this.form.endsAt || this.form.dismissible)
      );
    },
  },
  created() {
    // A audiencia existente ja entra selecionada E visivel na tabela: sem as
    // linhas, a unica pista de quem recebe seria o contador, e uma busca nova
    // sobrescreveria a lista sem o autor nunca ter visto o que havia.
    if (this.initialCompanies.length) {
      this.rows = this.initialCompanies.slice();
      this.selected = this.initialCompanies.slice();
      this.searched = true;
    }
  },
  methods: {
    companyLabel(row) {
      return row.name || row.cnpj || row.companyId;
    },
    downloadTemplate() {
      downloadCompanyTemplate();
    },
    key(row) {
      // Id de empresa e unico POR BANCO, nao globalmente: a chave precisa do
      // contexto junto, senao duas empresas de shards diferentes colidem.
      return row.contextCode + ':' + row.companyId;
    },
    isSelected(row) {
      const key = this.key(row);
      return this.selected.some((item) => this.key(item) === key);
    },
    clearSelection() {
      this.selected = [];
    },
    /**
     * Tira a empresa da selecao, da tabela E do campo de busca: se o termo
     * que a trouxe ficasse no campo, o proximo "Buscar" a traria de volta.
     * O termo casa por id, codigo de contexto, codigo, CNPJ (com ou sem
     * pontuacao) ou nome, sem diferenciar maiusculas.
     */
    remove(row) {
      const key = this.key(row);
      this.selected = this.selected.filter((item) => this.key(item) !== key);
      this.rows = this.rows.filter((item) => this.key(item) !== key);

      const digits = (value) => String(value || '').replace(/\D/g, '');
      const norm = (value) => String(value || '').trim().toLowerCase();
      const ids = [row.companyId, row.contextCode, row.code, row.name]
        .map(norm)
        .filter((value) => value.length > 0);
      const cnpj = digits(row.cnpj);

      const kept = splitCompanyTerms(this.terms).filter((term) => {
        const t = norm(term);
        if (ids.indexOf(t) !== -1) return false;
        if (cnpj && digits(term) === cnpj) return false;
        return true;
      });
      this.terms = kept.join(', ');
    },
    resolveFromTerms() {
      this.resolve(splitCompanyTerms(this.terms));
    },
    onFile(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      readCompanyTermsFromCsv(file)
        .then((terms) => {
          if (!terms.length) {
            this.sendError = 'A planilha não tem identificadores na primeira coluna.';
            return;
          }
          // O Figma pede que as empresas da planilha ja apareçam SELECIONADAS.
          this.resolve(terms, true);
        })
        .catch((error) => {
          this.sendError = error.message || 'Falha ao ler a planilha.';
        })
        .then(() => {
          // Permite reimportar o mesmo arquivo depois de corrigi-lo.
          event.target.value = '';
        });
    },
    /**
     * Uma unica rota resolve os quatro caminhos de entrada (colar, planilha,
     * filtro avancado e selecao manual), para a regra de casamento existir num
     * lugar so.
     */
    resolve(terms, autoSelect) {
      if (!terms.length) return;

      this.resolving = true;
      this.sendError = '';
      this.searchError = '';

      requestApiV2('POST', BROADCAST_RESOLVE_COMPANIES, { terms: terms })
        .then((response) => {
          const data = (response && response.data) || {};
          this.rows = data.items || [];
          this.notFound = data.notFound || [];
          this.notBrazil = data.notBrazil || [];
          this.shardsFailed = data.shardsFailed || [];
          this.searched = true;

          if (autoSelect) {
            this.rows.forEach((row) => {
              if (!this.isSelected(row)) this.selected.push(row);
            });
          }
        })
        .catch((error) => {
          // `searched` TEM de virar true tambem no erro: senao nem a tabela nem
          // o vazio renderizam e a secao simplesmente some da tela.
          this.searched = true;
          this.rows = [];

          var status = error && error.response && error.response.status;
          if (isNoCrossToken(error)) {
            this.searchError = 'Saia e entre novamente no Master para autenticar na API v2.';
          } else if (status === 404) {
            this.searchError =
              'Endpoint de busca não encontrado (404). A API de Avisos e Campanhas ' +
              'ainda não está publicada neste ambiente.';
          } else if (status === 401 || status === 403) {
            this.searchError =
              'Sem permissão para buscar empresas (' + status + '). É necessário um ' +
              'usuário operador da plataforma.';
          } else {
            this.searchError =
              'Não foi possível buscar as empresas' + (status ? ' (' + status + ')' : '') + '.';
          }
        })
        .then(() => {
          this.resolving = false;
        });
    },
    openPassword() {
      this.password = '';
      this.sendError = '';
      this.askPassword = true;
    },
    send() {
      if (!this.password || this.sending) return;

      // Confere antes de sair da tela: erro de digitacao vira feedback na
      // hora, sem ida e volta ate a API.
      if (this.password !== OPERATION_PASSWORD) {
        this.sendError = 'Senha incorreta.';
        return;
      }

      this.sending = true;
      this.sendError = '';

      const payload = {
        type: this.form.type,
        title: this.form.title,
        subtitle: this.form.subtitle || null,
        body: this.form.body || null,
        imageUrl: this.form.imageUrl || null,
        color: this.form.color,
        ctaLabel: this.form.ctaLabel || null,
        ctaUrl: this.form.ctaUrl || null,
        dismissible: this.form.dismissible,
        startsAt: this.form.startsAt,
        endsAt: this.form.endsAt || null,
        audience: audienceToMask(this.form.audience),
        surfaces: surfacesToMask(this.form.surfaces),
        targetAllActive: this.form.targetAllActive,
        // Com "todas as empresas" a lista vai vazia de proposito: quem resolve
        // a audiencia e o servidor, no momento do envio.
        companies: this.form.targetAllActive
          ? []
          : this.selected.map((row) => ({
              companyId: row.companyId,
              contextCode: row.contextCode,
            })),
      };

      const method = this.isEdit ? 'PUT' : 'POST';
      const url = this.isEdit ? BROADCAST_BY_ID(this.broadcastId) : BROADCASTS;

      requestApiV2(method, url, payload)
        .then((response) => {
          this.askPassword = false;
          this.$emit('sent', (response && response.data) || {});
        })
        .catch((error) => {
          const status = error && error.response && error.response.status;
          if (isNoCrossToken(error)) {
            this.sendError = 'Saia e entre novamente no Master para autenticar na API v2.';
          } else if (status === 403) {
            this.sendError = 'Sem permissão: é necessário um usuário operador da plataforma.';
          } else if (status === 400 && serverMessage(error)) {
            // Regra de negocio recusada: a frase do servidor diz o que corrigir,
            // por exemplo "Empresas fora do Brasil não podem receber avisos: X".
            this.sendError = serverMessage(error);
          } else {
            this.sendError = this.isEdit
              ? 'Não foi possível salvar o aviso.'
              : 'Não foi possível enviar o aviso.';
          }
        })
        .then(() => {
          this.sending = false;
        });
    },
  },
};
</script>

<style scoped>
.bc-notice__link { margin-left: 6px; color: #1b59f8; font-weight: 600; text-decoration: underline; }
.bc-section {
  width: 100%;
  margin: 18px 0 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid #eceff3;
  font-size: 13px;
  color: #4e5560;
}

/* Data tem sempre o mesmo tamanho: largura fixa, lado a lado. O calendario
   que abre e do navegador e nao muda. */
.bc-dates { display: flex; flex-wrap: wrap; gap: 0 16px; }
.bc-date { width: 180px; max-width: 100%; }
@media (max-width: 767px) {
  .bc-dates .form-group { flex: 1 1 100%; }
  .bc-date { width: 100%; }
}

.bc-hint { margin: 4px 0 0; font-size: 12px; color: #9ca0a7; }
.bc-notice {
  display: flex;
  align-items: center;
  margin: 0 0 4px;
  padding: 8px 12px;
  border: 1px solid #fdd944;
  background: #fff9eb;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #4e5560;
}
.bc-hint--error { color: #ff445d; }

/* O global `.filters button` desloca todo botao (top: 4px, margin-left: 17px,
   largura fixa 120px, radius 4px !important). "Planilha" e um <label>, entao
   nao recebia nada disso e ficava com outro raio e outra altura. Os dois
   viram itens iguais do flex: mesma altura do input, mesmo raio, sem
   deslocamento. */
.bc-audience__buttons { display: flex; gap: 8px; align-items: stretch; }
.bc-audience__buttons .btn {
  flex: 1 1 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: static;
  top: 0;
  width: auto;
  height: 34px;
  margin: 0;
  padding: 0 12px;
  border-radius: 4px;
  line-height: 1;
}
/* Mais especifico que `.bc-audience__buttons .btn` (position: static): sem
   isto o input invisivel do arquivo escapava do label e cobria o Buscar. */
.bc-audience__buttons .bc-audience__upload { position: relative; overflow: hidden; }
.bc-audience__upload input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.bc-chips {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 10px 0;
  padding: 10px 14px;
  border: 1px solid #d5d7da;
  border-radius: 6px;
}
.bc-chips__count { font-size: 13px; color: #3a424e; }
/* Mesmos resets do `.filters button` global: sem eles o link cai 4px e ganha
   margem, e deixa de alinhar com o contador ao lado. */
.bc-chips__clear {
  position: static;
  top: 0;
  width: auto;
  height: auto;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: #1b59f8;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}

.bc-actions { display: flex; justify-content: flex-end; gap: 10px; padding: 18px 0 6px; }
/* O global `.filters button` fixa 120px de largura: "Salvar alterações" nao
   cabe e o texto e cortado. Largura pelo conteudo, sem quebra de linha. */
.bc-actions .btn {
  position: static;
  top: 0;
  width: auto;
  min-width: 120px;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  white-space: nowrap;
}

.bc-modal {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
}
.bc-modal__box {
  width: 420px;
  max-width: 92vw;
  padding: 22px;
  background: #fff;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/broadcast/broadcastAudience.vue